<template>
  <div>
    <b-form>
      <ElementPasswordForm
        id="password"
        title="現在のパスワード"
        :vModel="formdata.password"
        type="password"
        @changed="formChanged"
      ></ElementPasswordForm>

      <ElementPasswordForm
        id="change_password"
        title="新しいパスワード"
        :vModel="formdata.change_password"
        :required="true"
        placeholder="8文字以上で入力してください"
        type="password"
        @changed="formChanged"
      ></ElementPasswordForm>

      <ElementPasswordForm
        id="confirm_password"
        title="新しいパスワード(確認)"
        :vModel="formdata.confirm_password"
        :required="true"
        type="password"
        @changed="formChanged"
      ></ElementPasswordForm>

      <b-container>
        <b-row>
          <p class="sm">
            ※パスワードには、半角英数と以下の記号が利用できます。
            <br />
            !"#$%&amp;'()*+,-./:;&lt;=&gt;?@[\]^_`{|}~
          </p>
        </b-row>
        <b-row>
          <b-col align="right">
            <b-button inline @click="closeModal()" class="mr-2">キャンセル</b-button>
            <b-button inline @click="handleClickSave" variant="default">保存</b-button>
          </b-col>
        </b-row>
      </b-container>
    </b-form>
  </div>
</template>

<script>
import api from '@/api'
import ElementPasswordForm from '@/components/presentationals/ElementPasswordForm.vue'
import { getErrorStatus } from '@/transformer/base'
export default {
  name: 'ProfileEdit',
  components: {
    ElementPasswordForm
  },
  data() {
    return {
      formdata: []
    }
  },
  methods: {
    formChanged(data) {
      this.formdata[data.id] = data.value
    },
    async handleClickSave() {
      try {
        await api.user.passwordUpdate(this.formdata)

        this.$root.$bvToast.toast('パスワードを変更しました。', {
          variant: 'success',
          toaster: 'b-toaster-top-center',
          autoHideDelay: 3000
        })
        this.closeModal()
        this.$emit('update')
      } catch (err) {
        const apiStatus = getErrorStatus(err)
        const errorMessages = []
        for (const key in apiStatus.errors) {
          errorMessages.push(`・${apiStatus.errors[key]}`)
        }
        this.$root.$bvToast.toast(errorMessages.join('\n'), {
          variant: 'danger',
          toaster: 'b-toaster-top-center',
          toastClass: 'pre-wrap',
          noAutoHide: true
        })
        if (apiStatus.status === 403 || apiStatus.status === 404) {
          // 該当のデータをうまくとれなかった場合は編集画面を閉じて更新
          this.closeModal()
          this.$emit('update')
        }
      }
    },
    closeModal() {
      this.$emit('closeModal')
    }
  }
}
</script>
